"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Title = _interopRequireDefault(require("@airasia/phoenix-components/components/Title"));

var _constant = require("@airasia/phoenix-components/components/Title/constant");

var _Link = _interopRequireDefault(require("@airasia/phoenix-components/components/Link"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _ShimmerCarousel = _interopRequireDefault(require("@airasia/phoenix-components/components/ShimmerCarousel"));

var _constant2 = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _cardTimer = require("../CardTimer/cardTimer.util");

var _constant3 = require("../CardTimer/constant");

var _CarouselSlider = _interopRequireDefault(require("../CarouselSlider"));

var _constant4 = require("./constant");

var _Carousel = _interopRequireDefault(require("./Carousel.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CarouselContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__CarouselContainer",
  componentId: "sc-bjf82e-0"
})(["display:flex;flex-direction:column;justify-content:flex-start;outline:none !important;height:100%;"]);

var TitleContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__TitleContainer",
  componentId: "sc-bjf82e-1"
})(["margin:", ";@media screen and (max-width:", "){margin:", ";}text-align:", ";"], function (_ref) {
  var titleMargin = _ref.titleMargin,
      theme = _ref.theme;
  return titleMargin || "0px ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.tiny);
}, _constant2.BREAKPOINTS.MOBILE, function (_ref2) {
  var theme = _ref2.theme;
  return "0px ".concat(theme.space.tiny, " ").concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref3) {
  var titleAlign = _ref3.titleAlign;
  return titleAlign || 'left';
});

TitleContainer.displayName = 'TitleContainer';

var SubHeadlineContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__SubHeadlineContainer",
  componentId: "sc-bjf82e-2"
})(["display:flex;", ";margin-top:0px;"], function (_ref4) {
  var titleAlign = _ref4.titleAlign;
  return titleAlign === 'center' && 'justify-content: center';
});

var TitleContainerForMob = _styledComponents.default.div.withConfig({
  displayName: "Carousel__TitleContainerForMob",
  componentId: "sc-bjf82e-3"
})(["display:flex;align-items:center;justify-content:space-between;text-align:", ";"], function (_ref5) {
  var titleAlign = _ref5.titleAlign;
  return titleAlign || 'left';
});

var LinkContainerForMob = _styledComponents.default.div.withConfig({
  displayName: "Carousel__LinkContainerForMob",
  componentId: "sc-bjf82e-4"
})(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;flex:1;"]);

var ShowMoreTextContainer = _styledComponents.default.div.withConfig({
  displayName: "Carousel__ShowMoreTextContainer",
  componentId: "sc-bjf82e-5"
})(["float:right;padding:5px;"]);

var StyledTitleComponent = (0, _styledComponents.default)(_Title.default).withConfig({
  displayName: "Carousel__StyledTitleComponent",
  componentId: "sc-bjf82e-6"
})(function (_ref6) {
  var theme = _ref6.theme,
      styledAs = _ref6.styledAs,
      headlineFontSize = _ref6.headlineFontSize,
      headlineFontWeight = _ref6.headlineFontWeight,
      headlineLineHeight = _ref6.headlineLineHeight,
      titleAlign = _ref6.titleAlign;
  return "\n\n  ".concat(styledAs === _constant.TITLE_TYPES.H2 ? "\n        font-size: ".concat(theme.fontSize.titleNormal, ";\n        font-weight: ").concat(theme.fontWeight.medium, ";\n        line-height: ").concat(theme.lineHeight.titleNormal, ";\n      ") : "", "\n\n  ").concat(styledAs === _constant.TITLE_TYPES.H3 ? "\n        font-size: ".concat(theme.fontSize.titleSmall, ";\n        font-weight: ").concat(theme.fontWeight.medium, ";\n        line-height: ").concat(theme.lineHeight.titleSmall, ";\n      ") : "", "\n\n  ").concat(styledAs === _constant.TITLE_TYPES.FREE_STYLE ? "\n        font-size: ".concat(headlineFontSize || theme.lineHeight.titleNormal, ";\n        font-weight: ").concat(headlineFontWeight || theme.fontWeight.medium, ";\n        line-height: ").concat(headlineLineHeight || theme.lineHeight.titleNormal, ";\n        text-align: ").concat(titleAlign || 'left', ";\n      ") : "", "\n    \n  ");
});

var Carousel = function Carousel(props) {
  var _useState = (0, _react.useState)(typeof window !== 'undefined' && window.innerWidth < 600),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var indexNumber = props.indexNumber,
      gtmConsumerName = props.gtmConsumerName,
      heading = props.heading,
      data = props.data,
      viewPort = props.viewPort,
      theme = props.theme,
      isLoading = props.isLoading,
      templateType = props.templateType,
      queryParams = props.queryParams,
      fireGtm = props.fireGtm,
      cardConfig = props.cardConfig,
      accessible = props.accessible,
      customProperties = props.customProperties,
      isIE = props.isIE,
      showFormattedPrice = props.showFormattedPrice,
      allowLocaleFormat = props.allowLocaleFormat,
      locale = props.locale,
      localeConfig = props.localeConfig,
      carouselWidgetOrder = props.carouselWidgetOrder,
      isHideFooter = props.isHideFooter,
      environment = props.environment,
      enableProgressiveImageLoading = props.enableProgressiveImageLoading,
      lazyLoadImage = props.lazyLoadImage,
      gaID = props.gaID,
      timerTimeZone = props.timerTimeZone;

  var _ref7 = heading || {},
      titleAlign = _ref7.titleAlign,
      titleMargin = _ref7.titleMargin,
      widgetWidth = _ref7.widgetWidth,
      headline = _ref7.headline,
      headlineStyle = _ref7.headlineStyle,
      headlineFontSize = _ref7.headlineFontSize,
      headlineFontWeight = _ref7.headlineFontWeight,
      headlineLineHeight = _ref7.headlineLineHeight,
      subHeadline = _ref7.subHeadline,
      subHeadlineFontSize = _ref7.subHeadlineFontSize,
      subHeadlineFontWeight = _ref7.subHeadlineFontWeight,
      subHeadlineFontColor = _ref7.subHeadlineFontColor,
      showMoreURL = _ref7.showMoreURL,
      widgetID = _ref7.widgetID,
      widgetName = _ref7.widgetName,
      gtmParameters = _ref7.gtmParameters,
      minCardsThreeColumn = _ref7.minCardsThreeColumn,
      showMoreText = _ref7.showMoreText,
      showMoreTextTarget = _ref7.showMoreTextTarget,
      decimalType = _ref7.decimalType,
      showMoreCallBack = _ref7.showMoreCallBack,
      showMoreType = _ref7.showMoreType,
      customCardHeaderHeight = _ref7.customCardHeaderHeight,
      hideBorder = _ref7.hideBorder;

  var headlineType = heading && heading.headlineType || 'h1';

  var _ref8 = gtmParameters || {},
      event = _ref8.event,
      eventActionClick = _ref8.eventActionClick,
      eventActionView = _ref8.eventActionView;

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hiddenCard = _useState4[0],
      setHiddenCard = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hideHeader = _useState6[0],
      setHideHeader = _useState6[1];

  var _ref9 = gtmParameters || {},
      eventCategory = _ref9.eventCategory,
      eventLabelView = _ref9.eventLabelView,
      eventLabelCardClick = _ref9.eventLabelCardClick,
      eventLabelHeadlineClick = _ref9.eventLabelHeadlineClick,
      eventSecondaryHeadlineClick = _ref9.eventSecondaryHeadlineClick;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allowAccessibility = _useState8[0],
      setAllowAccessibility = _useState8[1];

  var carouseContainerRef = (0, _react.useRef)(null);
  var headlineRef = (0, _react.useRef)(null);
  var subHeadlineRef = (0, _react.useRef)(null);
  var secondaryLinkRef = (0, _react.useRef)(null);

  var structureGtmData = function structureGtmData() {
    var totalNumberOfCard = data && Object.keys(data).length;
    eventLabelHeadlineClick = eventLabelHeadlineClick ? eventLabelHeadlineClick.replace('{{headline}}', headline || null) : null;
    eventSecondaryHeadlineClick = eventSecondaryHeadlineClick ? eventSecondaryHeadlineClick.replace('{{secondaryHeadline}}', secondaryLinkRef || null) : null;
    eventLabelCardClick = eventLabelCardClick ? eventLabelCardClick.replace('{{widgetorder}}', indexNumber || null).replace('{{carroouselwidgetorder}}', carouselWidgetOrder || null) : null;
    eventLabelView = eventLabelView ? eventLabelView.replace('{{carroouselwidgetorder}}', carouselWidgetOrder || null).replace('{{widgetorder}}', indexNumber || null).replace('{{totalNumberOfCards}}', totalNumberOfCard) : null;
    eventCategory = eventCategory ? eventCategory.replace('{{consumername}}', gtmConsumerName || null) : null;
  };

  var updateMedia = function updateMedia() {
    if (typeof window !== 'undefined') setIsMobile(window.innerWidth < 600);
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-use-before-define
      createGtmObject(); // view event

      window.addEventListener('resize', updateMedia);
    }

    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('resize', updateMedia) : null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // const tabIndex = !accessible ? '-1' : '0';

  var createGtmObject = function createGtmObject() {
    var dataForGtm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventLabelView;
    var click = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var obj = {
      event: event,
      'eventDetails.category': eventCategory,
      'eventDetails.action': "".concat(click ? eventActionClick : eventActionView),
      'eventDetails.label': dataForGtm
    }; // By default GTM will fire for Carousel
    // eslint-disable-next-line no-unused-expressions

    obj && fireGtm ? fireGtm(obj, 'true') : null;
  };

  var renderHeadline = function renderHeadline() {
    var headlineKeyDownHandler = function headlineKeyDownHandler() {
      setAllowAccessibility(true);

      if (subHeadlineRef && subHeadlineRef.current) {
        subHeadlineRef.current.focus();
      }

      if (secondaryLinkRef && secondaryLinkRef.current) {
        secondaryLinkRef.current.focus();
      }
    };

    var headlineContainer = !isMobile ? showMoreURL && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: headlineRef,
      color: _constant4.COLOR.HEADLINE_COLOR,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.HEADLINE_SIZE,
      target: "tab",
      theme: theme,
      gtmEventData: eventLabelHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(headline, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      }
    }, /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h2',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      accessible: false
    }, headline), !showMoreText && titleAlign !== 'center' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant4.COLOR.ICON_COLOR,
      fontsize: _constant4.SIZE.ICON_SIZE,
      icon: _constant4.ICON,
      theme: theme,
      accessible: false
    })), showMoreText && /*#__PURE__*/_react.default.createElement(ShowMoreTextContainer, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: secondaryLinkRef,
      color: _constant4.COLOR.SHOW_MORE_URL,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.SHOW_MORE_URL_SIZE,
      target: showMoreTextTarget,
      theme: theme,
      gtmEventData: eventSecondaryHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      callback: showMoreCallBack,
      type: showMoreType,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(showMoreText, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      }
    }, showMoreText))) || /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h2',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight
    }, headline) : showMoreURL && /*#__PURE__*/_react.default.createElement(TitleContainerForMob, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(LinkContainerForMob, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      color: _constant4.COLOR.HEADLINE_COLOR,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.HEADLINE_SIZE,
      target: "tab",
      theme: theme
    }, /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h3',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      textLimit: _constant4.SIZE.WITH_ICON_TEXT_LIMIT
    }, headline))), !showMoreText && titleAlign !== 'center' && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: _constant4.COLOR.ICON_COLOR,
      fontsize: _constant4.SIZE.ICON_SIZE,
      icon: _constant4.ICON,
      theme: theme
    }), showMoreText && /*#__PURE__*/_react.default.createElement(ShowMoreTextContainer, null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      ref: secondaryLinkRef,
      color: _constant4.COLOR.SHOW_MORE_URL,
      href: showMoreURL,
      queryParams: queryParams,
      hoverUnderlined: false,
      size: _constant4.SIZE.SHOW_MORE_URL_SIZE,
      target: showMoreTextTarget,
      theme: theme,
      gtmEventData: eventSecondaryHeadlineClick,
      fireGtm: createGtmObject,
      accessible: accessible,
      customProperties: {
        onKeyDown: function onKeyDown(e) {
          return _utilities.default.keyDownHandler(e, headlineKeyDownHandler, _constant2.KEY_CODE.ARROW_DOWN);
        },
        'aria-label': "".concat(showMoreText, ". Actionable Left click or press down arrow to proceed"),
        role: 'application'
      },
      idConfig: {
        parentName: 'carousel',
        widgetName: _utilities.default.replacedAll(widgetName)
      },
      callback: showMoreCallBack,
      type: showMoreType
    }, showMoreText))) || /*#__PURE__*/_react.default.createElement(StyledTitleComponent, {
      type: headlineType,
      styledAs: headlineStyle || 'h3',
      titleAlign: titleAlign,
      headlineFontSize: headlineFontSize,
      headlineFontWeight: headlineFontWeight,
      headlineLineHeight: headlineLineHeight,
      textLimit: titleAlign !== 'center' ? _constant4.SIZE.WITHOUT_ICON_TEXT_LIMIT : _constant4.SIZE.CENTER_HEADLINE_TEXT_LIMIT
    }, headline);
    return headline ? headlineContainer : null;
  };

  var renderSubHeadline = function renderSubHeadline() {
    return !isMobile ? subHeadline && /*#__PURE__*/_react.default.createElement(SubHeadlineContainer, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      ref: subHeadlineRef,
      theme: theme,
      type: subHeadlineFontSize || _constant4.SIZE.SUBHEADLINE_SIZE,
      bold: true,
      customProperties: {
        fontWeight: subHeadlineFontWeight
      },
      accessible: allowAccessibility,
      textAlign: titleAlign,
      color: subHeadlineFontColor
    }, subHeadline)) : subHeadline && /*#__PURE__*/_react.default.createElement(SubHeadlineContainer, {
      titleAlign: titleAlign
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      type: subHeadlineFontSize || _constant4.SIZE.SUBHEADLINE_SIZE_MOB,
      bold: true,
      customProperties: {
        fontWeight: subHeadlineFontWeight
      },
      textAlign: titleAlign,
      color: subHeadlineFontColor || _constant4.COLOR.SUBHEADLINE_COLOR_MOB
    }, subHeadline));
  };

  var colSpan = widgetWidth !== '' && widgetWidth || _constant4.ARR_COLUMN_SPAN[2];

  var carouselContainerKeyDownHandler = function carouselContainerKeyDownHandler() {
    setAllowAccessibility(false);

    if (headlineRef && headlineRef.current) {
      headlineRef.current.focus();
    }
  };

  var cardVisibilityHandler = function cardVisibilityHandler(index, isVisible) {
    if (!isVisible) {
      setHiddenCard(hiddenCard + 1);
    }
  };

  var timeZone = timerTimeZone && timerTimeZone.length > 0 ? timerTimeZone : _constant3.DEFAULT_TIMEZONE;
  var dateNow = (0, _cardTimer.convertDateToTimeZone)(new Date(), timeZone);
  (0, _react.useEffect)(function () {
    data.forEach(function (card) {
      if (card.timerEndDateTime) {
        var checkedTimerEndDateTime = (0, _cardTimer.checkDateTimeFormat)(card.timerEndDateTime);
        var endDate = new Date(checkedTimerEndDateTime);
        var expiredCard = 0;
        data.forEach(function () {
          if (dateNow > endDate) {
            expiredCard += 1;
          }
        });
        setHideHeader(expiredCard);
      }
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.length]);
  var visibleCards = data.length - hiddenCard;
  var cardCountThreshold = minCardsThreeColumn ? Number(minCardsThreeColumn) : 0;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, gtmParameters && structureGtmData(), visibleCards >= cardCountThreshold && visibleCards !== 0 && /*#__PURE__*/_react.default.createElement(CarouselContainer, (0, _extends2.default)({
    ref: carouseContainerRef,
    id: widgetID,
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, carouselContainerKeyDownHandler, _constant2.KEY_CODE.ESC);
    },
    onBlur: allowAccessibility ? function (e) {
      return _utilities.default.trapFocus(e, carouseContainerRef, headlineRef);
    } : null
  }, customProperties), (headline || subHeadline) && hideHeader !== data.length && /*#__PURE__*/_react.default.createElement(TitleContainer, {
    titleAlign: titleAlign,
    titleMargin: titleMargin
  }, [renderHeadline(), renderSubHeadline()]), isLoading ? /*#__PURE__*/_react.default.createElement(_ShimmerCarousel.default, null) : /*#__PURE__*/_react.default.createElement(_CarouselSlider.default, {
    theme: theme,
    environment: environment,
    templateType: templateType,
    data: data,
    queryParams: queryParams,
    columnSpan: colSpan,
    cardConfig: cardConfig,
    isIE: isIE,
    viewPort: viewPort,
    enableProgressiveImageLoading: enableProgressiveImageLoading,
    gtmEventData: eventLabelCardClick,
    lazyLoadImage: lazyLoadImage,
    fireGtm: createGtmObject,
    showFormattedPrice: showFormattedPrice,
    accessible: allowAccessibility,
    allowLocaleFormat: allowLocaleFormat,
    locale: locale,
    localeConfig: localeConfig,
    isHideFooter: isHideFooter,
    widgetID: widgetID,
    handleCardVisibility: cardVisibilityHandler,
    visibleCardCount: visibleCards,
    idConfig: {
      parentName: 'carousel',
      widgetName: _utilities.default.replacedAll(widgetName)
    },
    decimalType: decimalType,
    gaID: gaID,
    customCardHeaderHeight: customCardHeaderHeight,
    hideBorder: hideBorder
  })));
};

Carousel.propTypes = _Carousel.default.propTypes;
Carousel.defaultProps = _Carousel.default.DefaultProps;
var _default = Carousel;
exports.default = _default;